import React, { useState, useEffect } from 'react';
import '../../styles/slider.css';

const Slider = ({ slidesData, imageTitle,title }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);
  const [isHovered, setIsHovered] = useState(false); // Для отслеживания наведения

  // Автоматическое переключение слайдов
  useEffect(() => {
    if (isPlaying) {
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % slidesData.length);
      }, 5000); // Интервал 5 секунд
      return () => clearInterval(interval);
    }
  }, [isPlaying, slidesData.length]);

  // Функция для ручного переключения
  const goToSlide = (index) => {
    setCurrentSlide(index);
    setIsPlaying(false); // Останавливаем воспроизведение при ручной навигации
  };

  return (
    <div
      className="slider-container"
      onMouseEnter={() => setIsHovered(true)} // Показать кнопки при наведении
      onMouseLeave={() => setIsHovered(false)} // Скрыть кнопки при уходе
    >
      {/* Заголовок поверх слайда (опциональный) */}
      {imageTitle && (
        <div className="slider-title">
          <h1>{imageTitle}</h1>
        </div>
      )}

      {/* Слайд */}
      <div className="slider-image">
        <img src={slidesData[currentSlide]} alt={`Slide ${currentSlide + 1}`} />
      </div>

      {/* Кнопки управления */}
      <div className="slider-controls">
        {(!isPlaying || isHovered) && ( // Показывать кнопку только при паузе или наведении
          <button
            className="slider-play-pause"
            onClick={() => setIsPlaying(!isPlaying)}
          >
            {isPlaying ? (
              <img src="Pause.svg" alt="Pause" />
            ) : (
              <img src="Play Arrow.svg" alt="Play" />
            )}
          </button>
        )}
      </div>

      {/* Индикаторы */}
      <div className="slider-indicators">
        {slidesData.map((slide, index) => (
          <div
            key={index}
            className={`indicator ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
          ></div>
        ))}
      </div>
      <h2 className="gallery-slider-title">{title}</h2>
    </div>
  );
};

export default Slider;
